import { StringByKey } from '../types/common';

import folder from '../assets/images/drive/filetype_folder.svg';
import folder_using from '../assets/images/drive/filetype_folder_using.svg';
import image from '../assets/images/drive/filetype_img.svg';
import audio from '../assets/images/drive/filetype_mp3.svg';
import video from '../assets/images/drive/filetype_mp4.svg';

import xls from '../assets/images/drive/filetype_xls.svg';
import xlsx from '../assets/images/drive/filetype_xls.svg';
import ppt from '../assets/images/drive/filetype_ppt.svg';
import pptx from '../assets/images/drive/filetype_ppt.svg';
import doc from '../assets/images/drive/filetype_doc.svg';
import docx from '../assets/images/drive/filetype_doc.svg';
import pdf from '../assets/images/drive/filetype_pdf.svg';
import hwp from '../assets/images/drive/filetype_hwp.svg';
import hwpx from '../assets/images/drive/filetype_hwp.svg';
import zip from '../assets/images/drive/filetype_zip.svg';
import epub from '../assets/images/drive/filetype_epub.svg';
import web from '../assets/images/drive/filetype_web.svg';
import etc from '../assets/images/drive/filetype_etc.svg';

import { getFileType } from './util';

export const thumbnails: StringByKey = {
  folder,
  folder_using,
  image,
  audio,
  video,
  zip,
  xls,
  xlsx,
  ppt,
  pptx,
  doc,
  docx,
  pdf,
  hwp,
  hwpx,
  epub,
  web,
  etc,
};

export const getThumbnail = (ext: string) => {
  const type = getFileType(ext);
  return thumbnails[type];
};
